import { useTranslation } from 'react-i18next'

import { Badge, Tooltip } from '@enechain/ecloud-designsystem'

/** spot.html の spot-needs-review-chip: 状態の隣に印と説明を添える。 */
export const NeedsReviewChip = ({
  marginLeft = 1,
}: {
  marginLeft?: number
}): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Tooltip content={t('page:biddingSpot.needsReview.tooltip')} showArrow>
      <Badge marginLeft={marginLeft} status="warning" tabIndex={0}>
        {t('page:biddingSpot.needsReview.label')}
      </Badge>
    </Tooltip>
  )
}
